import React from 'react';
import { StaticGoogleMap, VisuallyHidden } from 'shared/components';
import { ListingStaticMapProps } from './ListingStaticMap.types';

import {
    ExpandButton,
    MapContainer,
    MapInner
} from './ListingStaticMap.styles';

const ListingStaticMap = ({ data, onMapClick }: ListingStaticMapProps) => {
    if (!data?.location?.coordinates) {
        return null;
    }
    const { latitude, longitude } = data.location.coordinates;

    if (!latitude || !longitude) {
        return null;
    }

    return (
        <MapContainer onClick={onMapClick} data-testid="static-map-container">
            <MapInner>
                <StaticGoogleMap
                    mapSizes={[
                        [375, 188],
                        [792, 398]
                    ]}
                    alt="Map of property location"
                    responsiveSizes="(min-width: 1232px) 792px, 100vw"
                    latitude={latitude}
                    longitude={longitude}
                    zoom={15}
                    marker={{
                        iconUrl: {
                            standard:
                                'https://r.zoocdn.com/assets/map-static-pin-purple-38.png',
                            retina:
                                'https://r.zoocdn.com/assets/map-static-pin-purple-76.png'
                        },
                        latitude,
                        longitude
                    }}
                    channel="Lex-LDP"
                    lazy={false}
                />
            </MapInner>
            <ExpandButton variant="secondary">
                <svg
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    role="presentation"
                    aria-hidden="true"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.6255 31.4451L19.9407 31.4451C20.3549 31.4451 20.6907 31.7809 20.6907 32.1951C20.6907 32.6093 20.3549 32.9451 19.9407 32.9451H13.8124C13.3982 32.9451 13.0624 32.6093 13.0624 32.1951V26.0669C13.0624 25.6526 13.3982 25.3169 13.8124 25.3169C14.2267 25.3169 14.5624 25.6526 14.5624 26.0669L14.5624 30.3868L20.297 24.6523C20.5899 24.3594 21.0647 24.3594 21.3576 24.6523C21.6505 24.9452 21.6505 25.4201 21.3576 25.7129L15.6255 31.4451Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M30.3609 14.5547L26.0593 14.5547C25.6451 14.5547 25.3093 14.2189 25.3093 13.8047C25.3093 13.3905 25.6451 13.0547 26.0593 13.0547H32.1876C32.6018 13.0547 32.9376 13.3905 32.9376 13.8047V19.9329C32.9376 20.3472 32.6018 20.6829 32.1876 20.6829C31.7734 20.6829 31.4376 20.3472 31.4376 19.9329V15.5993L25.6887 21.3482C25.3958 21.6411 24.9209 21.6411 24.6281 21.3482C24.3352 21.0553 24.3352 20.5804 24.6281 20.2875L30.3609 14.5547Z"
                        fill="currentColor"
                    />
                </svg>
                <VisuallyHidden>Expand map</VisuallyHidden>
            </ExpandButton>
        </MapContainer>
    );
};

export default ListingStaticMap;
